if (!customElements.get('calma-instagram-feed')) {
  class CalmaInstagramFeed extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.userId = this.dataset.userId;
      this.limit = parseInt(this.dataset.limit, 10);
      this.columnsDesktop = parseFloat(this.dataset.columnsDesktop);
      this.columnsMobile = parseFloat(this.dataset.columnsMobile);
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed, 10) || 4000;
      
      this.cK = 'calma_ig_' + this.sectionId + '_' + this.userId + '_' + this.limit;
      this.cTK = 'calma_ig_t_' + this.sectionId;
      this.cD = 86400000; // 24 hours caching
      
      this.modal = null;
      this.modalBody = null;
      this.modalUrl = null;
      this.currentVideo = null;
      
      this.timer = null;
      this.isPaused = false;
      this.page = 0;
      this.scrollT = null;
      this.rT = null;
    }
    
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      
      this.slider = this.querySelector('.slider-' + this.sectionId);
      this.nav = this.querySelector('.nav-' + this.sectionId);
      
      this.initIntersectionObserver();
    }
    
    initIntersectionObserver() {
      this.initObs = new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          this.classList.add('glory-visible');
          if (this.initObs) this.initObs.disconnect();
          this.fetchIG();
        }
      }, { rootMargin: '400px' });
      this.initObs.observe(this);
    }
    
    ensureModal() {
      if (this.modal) return;
      const S = this.sectionId;
      this.modal = document.createElement('dialog');
      this.modal.id = 'ig-modal-' + S;
      this.modal.className = 'ig-modal-' + S;
      this.modal.innerHTML = '<div class="ig-modal-content-' + S + '"><button class="ig-modal-close-' + S + '" type="button" aria-label="Cerrar modal"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button><div id="ig-modal-body-' + S + '" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;"></div><a id="ig-modal-url-' + S + '" class="ig-modal-link-' + S + '" href="#" target="_blank" rel="noopener noreferrer">Ver en Instagram</a></div>';
      document.body.appendChild(this.modal);
      this.modalBody = document.getElementById('ig-modal-body-' + S);
      this.modalUrl = document.getElementById('ig-modal-url-' + S);
      
      this.modal.querySelector('.ig-modal-close-' + S).addEventListener('click', () => this.closeModal());
      this.modal.addEventListener('close', () => this.closeModal());
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal || e.target.classList.contains('ig-modal-content-' + S)) this.closeModal();
      });
    }
    
    openModal(post) {
      this.ensureModal();
      this.modalBody.innerHTML = '';
      if (post.media_type === 'VIDEO') {
        const v = document.createElement('video');
        v.src = post.media_url;
        v.controls = true;
        v.autoplay = true;
        v.className = 'ig-modal-media-' + this.sectionId;
        this.modalBody.appendChild(v);
        this.currentVideo = v;
      } else {
        const img = document.createElement('img');
        img.src = post.media_url;
        img.className = 'ig-modal-media-' + this.sectionId;
        img.alt = 'Instagram photo';
        this.modalBody.appendChild(img);
      }
      this.modalUrl.href = post.permalink;
      this.modal.showModal();
      document.body.style.overflow = 'hidden';
    }
    
    closeModal() {
      if (!this.modal) return;
      this.modal.close();
      if (this.currentVideo) {
        this.currentVideo.pause();
        this.currentVideo.src = '';
        this.currentVideo = null;
      }
      this.modalBody.innerHTML = '';
      document.body.style.overflow = '';
    }
    
    renderFeed(data) {
      this.slider.innerHTML = '';
      const posts = data.slice(0, this.limit);
      const f = document.createDocumentFragment();
      posts.forEach(p => {
        const isV = p.media_type === 'VIDEO';
        const url = isV ? p.thumbnail_url : p.media_url;
        const cap = p.caption ? p.caption.slice(0, 50).replace(/"/g, '&quot;') : 'Instagram post';
        const btn = document.createElement('button');
        btn.className = 'slide-' + this.sectionId;
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Ver foto en grande');
        btn.innerHTML = '<img src="' + url + '" alt="' + cap + '" loading="lazy" decoding="async" fetchpriority="low">' + (isV ? '<div class="ig-video-icon-' + this.sectionId + '"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></div>' : '');
        btn.addEventListener('click', () => this.openModal(p));
        f.appendChild(btn);
      });
      this.slider.appendChild(f);
      this.initSlider();
    }
    
    hideSection() {
      this.style.display = 'none';
      this.setAttribute('aria-hidden', 'true');
    }
    
    fetchIG() {
      try {
        const cd = localStorage.getItem(this.cK);
        const ct = localStorage.getItem(this.cTK);
        if (cd && ct && (Date.now() - parseInt(ct, 10) < this.cD)) {
          const parsed = JSON.parse(cd);
          if (Array.isArray(parsed) && parsed.length) {
            this.renderFeed(parsed);
            return;
          }
        }
      } catch (e) {}
      
      this.fetchController = new AbortController();
      const tm = setTimeout(() => { if (this.fetchController) this.fetchController.abort(); }, 10000);
      fetch('https://ig-proxy-worker.glorytheshop.workers.dev/instagram-feed?user_id=' + this.userId + '&limit=' + this.limit, { signal: this.fetchController.signal })
        .then(r => {
          clearTimeout(tm);
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(d => {
          if (d.data && d.data.length) {
            try {
              localStorage.setItem(this.cK, JSON.stringify(d.data));
              localStorage.setItem(this.cTK, Date.now().toString());
            } catch (e) {}
            this.renderFeed(d.data);
          } else {
            this.hideSection();
          }
        })
        .catch(() => this.hideSection());
    }
    
    initSlider() {
      const slides = this.slider.children;
      const sa = Array.from(slides);
      
      const pv = () => window.innerWidth >= 990 ? this.columnsDesktop : window.innerWidth >= 750 ? 2 : Math.floor(this.columnsMobile);
      const tp = () => Math.ceil(slides.length / pv());
      
      const updateDots = () => {
        const dots = this.nav.children;
        for (let i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === this.page ? 'true' : 'false');
          dots[i].setAttribute('tabindex', i === this.page ? '0' : '-1');
        }
      };
      
      const go = (e) => {
        const t = tp() - 1;
        this.page = e > t ? 0 : e < 0 ? t : e;
        updateDots();
        this.resetTimer(go);
        const n = sa[this.page * pv()];
        if (n) this.slider.scrollTo({ left: n.offsetLeft, behavior: 'smooth' });
      };
      
      const initDots = () => {
        this.nav.innerHTML = '';
        const f = document.createDocumentFragment();
        const t = tp();
        if (t <= 1) return;
        for (let n = 0; n < t; n++) {
          const b = document.createElement('button');
          b.className = 'dot-' + this.sectionId;
          b.type = 'button';
          b.setAttribute('aria-label', 'Page ' + (n + 1));
          b.addEventListener('click', () => go(n));
          f.appendChild(b);
        }
        this.nav.appendChild(f);
        updateDots();
      };
      
      this.resetTimer = (goFn = go) => {
        if (!this.autoplay) return;
        clearTimeout(this.timer);
        if (!this.isPaused) {
          this.timer = setTimeout(() => goFn(this.page + 1), this.speed);
        }
      };
      
      this.slider.addEventListener('scroll', () => {
        if (this.scrollT) clearTimeout(this.scrollT);
        this.scrollT = setTimeout(() => {
          let closest = 0;
          let minD = Infinity;
          const p = pv();
          for (let i = 0; i < sa.length; i += p) {
            const d = Math.abs(sa[i].offsetLeft - this.slider.scrollLeft);
            if (d < minD) { minD = d; closest = i; }
          }
          const np = Math.floor(closest / p);
          if (np !== this.page) {
            this.page = np;
            updateDots();
            this.resetTimer();
          }
        }, 50);
      }, { passive: true });
      
      this.viewObs = new IntersectionObserver((e) => {
        this.isPaused = !e[0].isIntersecting;
        this.isPaused ? clearTimeout(this.timer) : this.resetTimer();
      }, { threshold: 0 });
      this.viewObs.observe(this);
      
      this.onResize = () => {
        clearTimeout(this.rT);
        this.rT = setTimeout(() => {
          initDots();
          go(this.page);
        }, 200);
      };
      window.addEventListener('resize', this.onResize, { passive: true });
      
      this.onmouseenter = () => { this.isPaused = true; clearTimeout(this.timer); };
      this.onmouseleave = () => { this.isPaused = false; this.resetTimer(); };
      
      initDots();
      this.resetTimer();
    }
    
    disconnectedCallback() {
      this.initialized = false;
      if (this.initObs) this.initObs.disconnect();
      if (this.fetchController) this.fetchController.abort();
      
      clearTimeout(this.timer);
      clearTimeout(this.rT);
      if (this.scrollT) clearTimeout(this.scrollT);
      if (this.viewObs) this.viewObs.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      this.onmouseenter = null;
      this.onmouseleave = null;
      if (this.modal && this.modal.parentNode) this.modal.parentNode.removeChild(this.modal);
    }
  }

  customElements.define('calma-instagram-feed', CalmaInstagramFeed);
}
